import React, { useState } from "react"
import Proptypes from "prop-types"
import { Container, Row, Col } from "reactstrap"
// import back from '../../../images/careers/Full Stack engineer.png';

const Consultpara = props => {
  return (
    <div className="main">
      <div className="headin medium-font">
        Support from Expertise to solve your problems
      </div>
      <div className="sub-headin2 medium-font">
        We recognise the important role of the community as leaders of WebRTC
        domain. Our{" "}
        <a href="https://meetrix.io/blog/" className="anchor">
          <b>blog</b>
        </a>{" "}
        provides some insights into our capabilities
      </div>
    </div>
  )
}

export default Consultpara
